<ng-container *transloco="let t">
  <app-editable-text
    appNavBreadcrumb
    [label]="spStrategy()?.name ?? ''"
    [tooltipText]="t('sp-strategy-group-page.change_strategy_group_name')"
    [disable]="!!isReadOnly()"
    (textChange)="strategyNameInput.set($event); updateStrategyName()"
  />
  @if (!loading() && tacosStrategyEx()) {
    <div class="container mx-auto flex min-h-full flex-col rounded-lg bg-white px-10 py-6">
      <app-state-badge
        class="mb-2"
        [state]="tacosStrategyEx()!.state"
        [loading]="stateUpdateLoading()"
        (stateBadgeClick)="updateStrategyGroupState($event)"
        [disabled]="!!isReadOnly()"
      />
      <div class="flex w-full gap-2 pb-3">
        <app-strategy-info-bloc (strategyInfoClick)="openTargetModal()" [disabled]="!!isReadOnly()">
          <div title class="text-sm text-gray-500 uppercase">{{ t("strategy-table.target") }}</div>
          @if (tacosStrategyEx()) {
            <div body class="ml-0.5 font-medium">{{ tacosStrategyEx()!.tacosTarget! * 100 | number: "1.0-1" }} %</div>
          } @else {
            <div body class="mt-1 h-6 w-14 animate-pulse rounded-md bg-gray-200"></div>
          }
        </app-strategy-info-bloc>
      </div>

      <ITabs [tabs]="tabs()" [(activeTab)]="activeTab" />

      <div class="flex-1 pt-5">
        @if (selectedSection() === Section.STATS) {
          @if (tacosStrategyEx() && spStrategy()) {
            <app-tacos-stats [tacosStrategy]="tacosStrategyEx()!" />
          }
        } @else if (selectedSection() === Section.PRODUCTS) {
          @if (tacosStrategyEx() && spStrategy() && am()) {
            <app-tacos-products
              [tacosStrategy]="tacosStrategyEx()!"
              [sbAsins]="sbAsins()"
              [missingAsinsInSb]="missingAsinsInSb()"
              [am]="am()!"
              [isReadOnly]="!!isReadOnly()"
            />
          }
        } @else if (selectedSection() === Section.CAMPAIGNS) {
          @if (spStrategy() && am() && tacosStrategyEx()) {
            <app-tacos-ad-types
              [am]="am()!"
              [tacosStrategy]="tacosStrategyEx()!"
              [sbAsins]="sbAsinsString()"
              [missingAsinsInSb]="missingAsinsInSb()"
              [isReadonly]="!!isReadOnly()"
            />
          }
        } @else if (selectedSection() === Section.ACTIVITIES) {
          <div class="ag-theme-quartz h-[30rem]">
            <app-activity-component
              [activityFilter]="activityFilter()"
              [hideEntityColumn]="true"
              gridConfigStorageKey="strategyActivities"
            />
          </div>
        }
      </div>
    </div>
  } @else if (loading()) {
    <div class="flex h-full items-center justify-center">
      <ISpinner [display]="true" />
    </div>
  }

  <ng-template #targetModal>
    <div class="w-[20vw]">
      <div class="py-5">
        <IFormField>
          <label iLabel>{{ t("strategy-table.target") }}</label>
          <div iInputGroup>
            <input
              iInputGroupInput
              [ngModel]="tacosStrategyEx()?.tacosTarget! * 100 | number: '1.0-1'"
              [placeholder]="t('strategy-table.target')"
              [type]="'number'"
              [min]="0"
              [max]="100"
              [autofocus]="true"
              (ngModelChange)="tacosTargetInput.set(+$event)"
            />
            <span iInputGroupSuffix><IIcon name="percent" /></span>
          </div>
        </IFormField>
      </div>
      <div class="mt-4 flex justify-end gap-2">
        <button iButton variant="secondary" size="md" (click)="hideModal()">{{ t("common.cancel") }}</button>
        <button iButton size="md" [loading]="modalLoading()" (click)="updateTacosTarget()">
          {{ t("common.save") }}
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #editNameModal>
    <div class="w-[20vw]">
      <div class="py-5">
        <IFormField>
          <label iLabel>{{ t("common.name") }}</label>
          <input
            iInput
            [ngModel]="spStrategy()?.name!"
            (ngModelChange)="strategyNameInput.set($event)"
            [placeholder]="t('common.name')"
            autofocus
          />
        </IFormField>
      </div>
      <div class="mt-4 flex justify-end gap-2">
        <button iButton variant="secondary" size="md" (click)="hideModal()">{{ t("common.cancel") }}</button>
        <button iButton size="md" [loading]="modalLoading()" (click)="updateStrategyName()">
          {{ t("common.save") }}
        </button>
      </div>
    </div>
  </ng-template>
</ng-container>
